// eslint-disable-next-line import/prefer-default-export
export function capitalizeFirstLetterEachWord(value: string): string {
  if (value) {
    return value.toLowerCase().replace(/(^\w{1})|(\s{1}\w{1})/g, (match: string) => match.toUpperCase());
  }

  return null;
}
